import { useCallback, useEffect, useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "redux-store";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContainer: {
      // backgroundColor: "#eeeeee",
      padding: "1em",
    },
    sectionHeader: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      marginBottom: "1em",
      [theme.breakpoints.down("xs")]: {
        display: "block",
      },
    },
    appLogo: {
      height: "80px",
      marginRight: "2em",
    },
    sectionName: {
      textTransform: "uppercase",
      color: "black",
      fontWeight: "bold",
    },
    merchantsContainer: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-around",
    },
    addMerchant: {
      width: "100%",
      height: "100%",
      display: "flex",
      minHeight: 300,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "transparent",
      cursor: "pointer",
      border: "2px dashed black",
      transition: "0.3s",
      [theme.breakpoints.down("xs")]: {
        minHeight: "unset",
      },
      "&:hover": {
        backgroundColor: "white",
        border: `2px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
      },
    },
    addIcon: {
      fontSize: "2.5rem",
    },
  }),
);

const useMerchantsOverview = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const dispatch = useDispatch();
  const merchants = useSelector(selectors.getMerchantsList);
  const [t] = useTypedTranslations();

  const handleDialogOpen = useCallback(() => {
    dispatch(actions.setIsCreateMerchantDialogOpen(true));
  }, [dispatch]);

  useEffect(() => {
    dispatch(actions.getMerchants.request({}));
  }, [dispatch]);

  return {
    styles,
    classes,
    atomicStyles,
    merchants,
    handleDialogOpen,
    t,
  };
};

export { useMerchantsOverview as default };
